import { ReloadOutlined } from "@ant-design/icons"
import { Button, Space, type TableColumnsType } from "antd"
import type { TFunction } from "react-i18next"

import type { AccountDeletionRequest } from "../../types/types.ts"

interface GetActionsArgs {
  t: TFunction
  canManage: boolean
  deciding?: boolean
  onApprove: (r: AccountDeletionRequest) => void
  onReject: (r: AccountDeletionRequest) => void
  onRetry: (r: AccountDeletionRequest) => void
}

type ActionsColumn = TableColumnsType<AccountDeletionRequest>[number]

export const getActions = ({
  t,
  canManage,
  deciding,
  onApprove,
  onReject,
  onRetry
}: GetActionsArgs): ActionsColumn => ({
  title: "",
  key: "actions",
  fixed: "right",
  width: 220,
  render: (_: unknown, r: AccountDeletionRequest) => {
    if (!canManage) return null

    if (r.status === "pending") {
      return (
        <Space>
          <Button type="primary" onClick={() => onApprove(r)}>
            {t("accountDeletionRequests.actions.approve")}
          </Button>
          <Button danger onClick={() => onReject(r)}>
            {t("accountDeletionRequests.actions.reject")}
          </Button>
        </Space>
      )
    }

    // `processing` is transient — it should flip to `completed` within seconds.
    // A row sitting here means finalize failed, and Celery has already burned
    // its retries; this is the admin's only way to re-run it.
    if (r.status === "processing") {
      return (
        <Button
          icon={<ReloadOutlined />}
          loading={deciding}
          onClick={() => onRetry(r)}
        >
          {t("accountDeletionRequests.actions.retry")}
        </Button>
      )
    }

    return null
  }
})
